import Service from '../../services';
import { getQueryString } from '../../utils/params';

export const fetchListProperties = async params => {
  const response = await Service.get(`api/properties/${params.type}${getQueryString(params.params)}`, res => res);
  return response;
};
